export default __webpack_public_path__ + "static/apace_2-4f9c4c9ad1c5b54040ad4d08d4f65687.png";